import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-business-equipment-tuple',
  templateUrl: './business-equipment-tuple.component.html',
})
/**
 * Business Equipment Tuple
 */
export class BusinessEquipmentTupleComponent implements OnInit {
  @Input() index!: number;
  @Input() label!: string;
  @Output() removeTuple = new EventEmitter<number | FormGroup>();
  @Input() formGroup?: FormGroup;
  @Input() hasMoreEquipment?: boolean;
  canRemoveTuple?: boolean;
  existingEquipment?: boolean;

  /**
   * Initializer
   */
  ngOnInit(): void {
    this.existingEquipment = this.formGroup?.controls['serial'].value !== '';
    this.canRemoveTuple = this.hasMoreEquipment;
  }

  /** Getter
   * @return {FormControl}
   */
  get serial() {
    return this.formGroup?.get('serial') as FormControl;
  }

  /** Getter
   * @return {FormControl}
   */
  get id() {
    return this.formGroup?.get('id');
  }

  /** Getter
   * @return {FormControl}
   */
  get planModel() {
    return this.formGroup?.get('planModel');
  }

  /** Getter
   * @return {FormControl}
   */
  get familyName() {
    return this.formGroup?.get('familyName');
  }
}
